module.exports = __webpack_public_path__ + "img/7m.2189346f.jpg";